var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4974 29.3332C9.1336 29.3332 3.16406 23.3636 3.16406 15.9998C3.16406 8.63604 9.1336 2.6665 16.4974 2.6665C23.8611 2.6665 29.8307 8.63604 29.8307 15.9998C29.8307 23.3636 23.8611 29.3332 16.4974 29.3332ZM16.4974 14.1142L12.7262 10.343L10.8405 12.2286L14.6118 15.9998L10.8405 19.771L12.7262 21.6566L16.4974 17.8854L20.2686 21.6566L22.1542 19.771L18.383 15.9998L22.1542 12.2286L20.2686 10.343L16.4974 14.1142Z",
    fill: "#CF0F37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.23a7c80c3d706660e705bd3bcd93706f.svg";
export { ForwardRef as ReactComponent };